import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, InputNumber, DatePicker, Icon, notification, Checkbox, Radio, Divider } from "antd";
import axios from "axios";
import moment from "moment";
import SectionCard from "../../components/SectionCard";
import SectionDivider from "../../components/SectionDivider";

const { TextArea } = Input;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message,
        description
    });
};

const parseObject = (value, fallback = {}) => {
    if (!value) return fallback;
    if (typeof value === "object" && !Array.isArray(value)) return value;

    try {
        const parsed = JSON.parse(value);
        return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : fallback;
    } catch {
        return fallback;
    }
};

const parseArray = value => {
    if (!value) return [];
    if (Array.isArray(value)) return value;

    try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
};

const DrawerAdicionarEstudoPreEscola = ({ id, pastaId, visible, atualizarListagem, onClose, form }) => {
    const estadoInicial = {
        id: undefined,
        id_disciplina: undefined,
        data_realizacao: moment(),
        descricao: "",
        tecnicas_utilizadas: "",

        nome_crianca: "",
        turma_ano: "",
        idade: null,
        professor: "",
        data_registro: moment(),

        adaptacao_escolar: [],
        interacao_socializacao: [],
        comunicacao: [],
        comportamento: [],
        rotina_autonomia: [],
        realizado_com_crianca: [],

        funciona_melhor: "",
        precisa_trabalhado: "",

        observacoes_familia_relato: "",
        observacoes_familia_estrategias: "",

        familia_ciente_intervencoes: null,
        familia_disponibilidade_parceria: null,
        familia_atividades_terapias_externas: null,
        familia_atividades_terapias_dias: [],
        familia_atividades_terapias_quais: "",
        combinado_escola_familia: "",

        recomendacoes_finais: ""
    };

    const [registo, setRegisto] = useState(estadoInicial);
    const [isLoading, setIsLoading] = useState(false);

    const opcoesAdaptacaoEscolar = [
        "Chora em sala",
        "Apresenta dificuldade de socialização",
        "Resiste à entrada",
        "Aceita combinados",
        "Participa das atividades"
    ];

    const opcoesInteracaoSocializacao = [
        "Dificuldade de leitura",
        "Reconhecimento de letras, números, formas, cores",
        "Realiza atividades com autonomia ",
        "Motricidade fina (uso de tesoura, lápis, massa de modelar)",
        "Motricidade grossa (correr, pular, controle do corpo, dança, jogos)",
        "Realiza atividades com apoio parcial ou total  ",
        "Não realiza atividades "
    ];

    const opcoesComportamento = [
        "Calmo",
        "Frustação fácil",
        "Falta de atenção",
        "Impulsividade",
        "Irritabilidade",
        "Ansiedade",
        "Recusa seguir regras"
    ];

    const opcoesComunicacao = [
        "Vocabulário limitado",
        "Problemas para organizar frases",
        "Dificuldade em seguir instruções",
        "Troca sons na fala",
        "Compreende comandos"
    ];

    const opcoesRotinaAutonomia = [
        "Cumpre combinados e participa da rotina",
        "Organiza materiais",
        "Usa banheiro",
        "Alimenta-se sozinho",
        "Em desfralde",
        "Precisa de ajuda"
    ];

    const opcoesRealizadoCrianca = [
        "Atividades adaptadas",
        "Atendimento individual",
        "Uso de recursos visuais ",
        "Mudança de lugar",
        "Reunião com a família"
    ];

    const opcoesDiasSemana = ["2ª", "3ª", "4ª", "5ª", "6ª"];

    const { getFieldDecorator, getFieldValue } = form;

    const handleSubmit = e => {
        e.preventDefault();

        form.validateFields((err, values) => {
            if (!err) {
                if (id) {
                    alterarEstudo(values);
                } else {
                    adicionarEstudo(values);
                }
            }
        });
    };

    const carregarDetalhe = id => {
        setIsLoading(true);

        axios({
            method: "get",
            url: "/api/estudo-caso/carregar-estudo-infantil",
            params: {
                id
            }
        })
            .then(response => {
                const dados = response.data;

                const observacoes = parseObject(dados.observacoes_familia, {
                    observacoes_familia_relato: "",
                    observacoes_familia_estrategias: ""
                });

                const alinhamento = parseObject(dados.alinhamento_escola_familia, {
                    familia_ciente_intervencoes: null,
                    familia_disponibilidade_parceria: null,
                    familia_atividades_terapias_externas: null,
                    familia_atividades_terapias_dias: [],
                    familia_atividades_terapias_quais: "",
                    combinado_escola_familia: ""
                });

                const registoTratado = {
                    ...dados,
                    adaptacao_escolar: parseArray(dados.adaptacao_escolar),
                    interacao_socializacao: parseArray(dados.interacao_socializacao),
                    comunicacao: parseArray(dados.comunicacao),
                    comportamento: parseArray(dados.comportamento),
                    rotina_autonomia: parseArray(dados.rotina_autonomia),
                    realizado_com_crianca: parseArray(dados.realizado_com_crianca),
                    data_registro: dados.data_registro ? moment(dados.data_registro) : moment(),

                    observacoes_familia_relato: observacoes.observacoes_familia_relato || "",
                    observacoes_familia_estrategias: observacoes.observacoes_familia_estrategias || "",

                    familia_ciente_intervencoes: alinhamento.familia_ciente_intervencoes || null,
                    familia_disponibilidade_parceria: alinhamento.familia_disponibilidade_parceria || null,
                    familia_atividades_terapias_externas: alinhamento.familia_atividades_terapias_externas || null,
                    familia_atividades_terapias_dias: parseArray(alinhamento.familia_atividades_terapias_dias),
                    familia_atividades_terapias_quais: alinhamento.familia_atividades_terapias_quais || "",
                    combinado_escola_familia: alinhamento.combinado_escola_familia || ""
                };

                setRegisto(registoTratado);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Ocorreu um erro ao carregar o detalhe.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const adicionarEstudo = values => {
        setIsLoading(true);

        const estudo = {
            id_disciplina: localStorage.getItem("codigo_curso"),
            tipo: "estudo_caso_infantil_pre_escola",
            nome_crianca: values.nome_crianca,
            turma_ano: values.turma_ano,
            idade: values.idade,
            professor: values.professor,
            data_registro: values.data_registro ? values.data_registro.format("YYYY-MM-DD") : null,

            adaptacao_escolar: JSON.stringify(values.adaptacao_escolar || []),
            interacao_socializacao: JSON.stringify(values.interacao_socializacao || []),
            comunicacao: JSON.stringify(values.comunicacao || []),
            comportamento: JSON.stringify(values.comportamento || []),
            rotina_autonomia: JSON.stringify(values.rotina_autonomia || []),
            realizado_com_crianca: JSON.stringify(values.realizado_com_crianca || []),

            funciona_melhor: values.funciona_melhor,
            precisa_trabalhado: values.precisa_trabalhado,

            observacoes_familia: JSON.stringify({
                observacoes_familia_relato: values.observacoes_familia_relato || "",
                observacoes_familia_estrategias: values.observacoes_familia_estrategias || ""
            }),

            alinhamento_escola_familia: JSON.stringify({
                familia_ciente_intervencoes: values.familia_ciente_intervencoes || null,
                familia_disponibilidade_parceria: values.familia_disponibilidade_parceria || null,
                familia_atividades_terapias_externas: values.familia_atividades_terapias_externas || null,
                familia_atividades_terapias_dias: values.familia_atividades_terapias_dias || [],
                familia_atividades_terapias_quais: values.familia_atividades_terapias_quais || "",
                combinado_escola_familia: values.combinado_escola_familia || ""
            }),

            recomendacoes_finais: values.recomendacoes_finais
        };

        axios({
            method: "post",
            url: "/api/estudo-caso/adicionar-plano-estudo-infantil",
            data: estudo
        })
            .then(response => {
                openNotificationWithIcon("success", "Sucesso", "Estudo de caso criado com sucesso.");
                atualizarListagem(response.data);
                handleClose();
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Erro ao criar o estudo.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const alterarEstudo = values => {
        setIsLoading(true);

        const estudo = {
            id: id,
            nome_crianca: values.nome_crianca,
            turma_ano: values.turma_ano,
            idade: values.idade,
            professor: values.professor,
            data_registro: values.data_registro ? values.data_registro.format("YYYY-MM-DD") : null,

            adaptacao_escolar: JSON.stringify(values.adaptacao_escolar || []),
            interacao_socializacao: JSON.stringify(values.interacao_socializacao || []),
            comunicacao: JSON.stringify(values.comunicacao || []),
            comportamento: JSON.stringify(values.comportamento || []),
            rotina_autonomia: JSON.stringify(values.rotina_autonomia || []),
            realizado_com_crianca: JSON.stringify(values.realizado_com_crianca || []),

            funciona_melhor: values.funciona_melhor,
            precisa_trabalhado: values.precisa_trabalhado,

            observacoes_familia: JSON.stringify({
                observacoes_familia_relato: values.observacoes_familia_relato || "",
                observacoes_familia_estrategias: values.observacoes_familia_estrategias || ""
            }),

            alinhamento_escola_familia: JSON.stringify({
                familia_ciente_intervencoes: values.familia_ciente_intervencoes || null,
                familia_disponibilidade_parceria: values.familia_disponibilidade_parceria || null,
                familia_atividades_terapias_externas: values.familia_atividades_terapias_externas || null,
                familia_atividades_terapias_dias: values.familia_atividades_terapias_dias || [],
                familia_atividades_terapias_quais: values.familia_atividades_terapias_quais || "",
                combinado_escola_familia: values.combinado_escola_familia || ""
            }),

            recomendacoes_finais: values.recomendacoes_finais
        };

        axios({
            method: "put",
            url: "/api/estudo-caso/alterar-plano-estudo-infantil",
            data: estudo
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Estudo de caso alterado com sucesso.");
                atualizarListagem();
                handleClose();
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Ocorreu um erro ao alterar o estudo de caso.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const carregarDadosAluno = () => {
        axios({
            method: "get",
            url: "/api/estudo-caso/carregar-informacoes",
            params: {
                pastaId,
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                const { aluno, turma } = response.data;

                setRegisto(prevState => ({
                    ...prevState,
                    nome_crianca: aluno?.nome || "",
                    turma_ano: turma?.nome || "",
                    idade: aluno?.idade ?? null,
                    professor: turma?.professor || ""
                }));
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao carregar dados.");
            });
    };

    const carregarDadosAlunoEnsinoEspecial = () => {
        axios({
            method: "get",
            url: "/api/estudo-caso/carregar-informacoes-ensino-especial",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                const { aluno, turma } = response.data;

                setRegisto(prevState => ({
                    ...prevState,
                    nome_crianca: aluno?.nome || "",
                    turma_ano: turma?.nome || "",
                    idade: aluno?.idade ?? null,
                    professor: turma?.professor || ""
                }));
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao carregar dados.");
            });
    };

    const handleClose = () => {
        onClose();
        limparCampos();
    };

    const afterVisibleChange = aberto => {
        if (!aberto && id === null) {
            limparCampos();
        }
    };

    const limparCampos = () => {
        form.resetFields();
        setRegisto(estadoInicial);
    };

    useEffect(() => {
        if (visible && id) {
            carregarDetalhe(id);
        }
        if (pastaId && visible) {
            carregarDadosAluno();
        }
        if (visible && !id && !pastaId) {
            carregarDadosAlunoEnsinoEspecial();
        }
    }, [id, visible]);

    const renderCheckboxSection = (label, fieldName, options) => (
        <div className="bloco" style={{ marginBottom: 30 }}>
            <SectionCard title={label}>
                <Form.Item style={{ marginBottom: 15 }}>
                    {getFieldDecorator(fieldName, {
                        initialValue: registo[fieldName] || []
                    })(
                        <Checkbox.Group style={{ width: "100%" }}>
                            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                                {options.map(opcao => (
                                    <Checkbox key={opcao} value={opcao}>
                                        {opcao}
                                    </Checkbox>
                                ))}
                            </div>
                        </Checkbox.Group>
                    )}
                </Form.Item>
            </SectionCard>
        </div>
    );

    return (
        <Drawer
            className="drawer-adicionar-evento drawer-add-cursos"
            width={720}
            onClose={handleClose}
            visible={visible}
            style={{
                overflow: "auto",
                height: "calc(100% - 108px)",
                paddingBottom: "108px"
            }}
            maskClosable={false}
            afterVisibleChange={afterVisibleChange}
        >
            <div className="bloco-info">
                <Form className="form-categorias" layout="horizontal" onSubmit={handleSubmit}>
                    <SectionCard title="1. Dados da criança">
                        <Form.Item label="Nome da criança">
                            {getFieldDecorator("nome_crianca", {
                                initialValue: registo.nome_crianca,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>
                        <Form.Item label="Turma/ano">
                            {getFieldDecorator("turma_ano", {
                                initialValue: registo.turma_ano,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>
                        <Form.Item label="Idade">
                            {getFieldDecorator("idade", {
                                initialValue: registo.idade,
                                rules: [
                                    { required: true, message: "Campo obrigatório" },
                                    { type: "number", message: "Apenas números são permitidos" }
                                ]
                            })(<InputNumber min={0} precision={0} />)}
                        </Form.Item>
                        <Form.Item label="Professor(a)">
                            {getFieldDecorator("professor", {
                                initialValue: registo.professor,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>
                        <Form.Item label="Data">
                            {getFieldDecorator("data_registro", {
                                initialValue: registo.data_registro,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<DatePicker format="DD-MM-YYYY" />)}
                        </Form.Item>
                    </SectionCard>

                    {renderCheckboxSection("2. Adaptação Escolar", "adaptacao_escolar", opcoesAdaptacaoEscolar)}
                    {renderCheckboxSection("3. Aprendizagem", "interacao_socializacao", opcoesInteracaoSocializacao)}
                    {renderCheckboxSection("4. Comportamento", "comportamento", opcoesComportamento)}
                    {renderCheckboxSection("5. Linguagem e comunicação", "comunicacao", opcoesComunicacao)}
                    {renderCheckboxSection("6.  Rotina escolar e autonomia", "rotina_autonomia", opcoesRotinaAutonomia)}
                    {renderCheckboxSection("7. O que já foi feito", "realizado_com_crianca", opcoesRealizadoCrianca)}

                    <SectionCard title="8. O que precisa ser trabalhado">
                        <Form.Item label="Descrição">
                            {getFieldDecorator("precisa_trabalhado", {
                                initialValue: registo.precisa_trabalhado
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item>
                    </SectionCard>

                    <SectionCard title="9. Observações da família">
                        <Form.Item label="Relato sobre o desenvolvimento da criança e preocupações da família">
                            {getFieldDecorator("observacoes_familia_relato", {
                                initialValue: registo.observacoes_familia_relato
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item>

                        <Form.Item label="O que a família considera que ajuda a criança a aprender melhor?">
                            {getFieldDecorator("observacoes_familia_estrategias", {
                                initialValue: registo.observacoes_familia_estrategias
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item>

                        <Divider orientation="left" style={{ fontWeight: "bold" }}>
                            Alinhamento Escola e Familiar
                        </Divider>

                        <Form.Item label="A família está ciente das intervenções pedagógicas">
                            {getFieldDecorator("familia_ciente_intervencoes", {
                                initialValue: registo.familia_ciente_intervencoes
                            })(
                                <Radio.Group>
                                    <Radio value="sim">Sim</Radio>
                                    <Radio value="parcialmente">Parcialmente</Radio>
                                    <Radio value="nao">Não</Radio>
                                </Radio.Group>
                            )}
                        </Form.Item>

                        <Form.Item label="A família demonstra disponibilidade para parceria com a escola">
                            {getFieldDecorator("familia_disponibilidade_parceria", {
                                initialValue: registo.familia_disponibilidade_parceria
                            })(
                                <Radio.Group>
                                    <Radio value="sim">Sim</Radio>
                                    <Radio value="parcialmente">Parcialmente</Radio>
                                    <Radio value="nao">Não</Radio>
                                </Radio.Group>
                            )}
                        </Form.Item>

                        <Form.Item label="A família leva a criança para atividades ou terapias externas">
                            {getFieldDecorator("familia_atividades_terapias_externas", {
                                initialValue: registo.familia_atividades_terapias_externas
                            })(
                                <Radio.Group>
                                    <Radio value="sim">Sim</Radio>
                                    <Radio value="nao">Não</Radio>
                                </Radio.Group>
                            )}
                        </Form.Item>

                        <Form.Item label="Dias da semana">
                            {getFieldDecorator("familia_atividades_terapias_dias", {
                                initialValue: registo.familia_atividades_terapias_dias || []
                            })(
                                <Checkbox.Group
                                    style={{ width: "100%" }}
                                    disabled={getFieldValue("familia_atividades_terapias_externas") !== "sim"}
                                >
                                    {opcoesDiasSemana.map(dia => (
                                        <Checkbox key={dia} value={dia} style={{ marginRight: 12 }}>
                                            {dia}
                                        </Checkbox>
                                    ))}
                                </Checkbox.Group>
                            )}
                        </Form.Item>

                        <Form.Item label="Quais">
                            {getFieldDecorator("familia_atividades_terapias_quais", {
                                initialValue: registo.familia_atividades_terapias_quais
                            })(
                                <TextArea
                                    rows={5}
                                    style={{ minHeight: 100 }}
                                    disabled={getFieldValue("familia_atividades_terapias_externas") !== "sim"}
                                />
                            )}
                        </Form.Item>

                        <Form.Item label="Combinado entre escola e família / orientações">
                            {getFieldDecorator("combinado_escola_familia", {
                                initialValue: registo.combinado_escola_familia
                            })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                        </Form.Item>
                    </SectionCard>

                    <SectionCard title="10. Recomendações finais">
                        {getFieldDecorator("recomendacoes_finais", {
                            initialValue: registo.recomendacoes_finais
                        })(<TextArea rows={5} style={{ minHeight: 100 }} />)}
                    </SectionCard>

                    <div className="ant-drawer-footer">
                        <button
                            className="botao-secundario"
                            type="button"
                            onClick={handleClose}
                            style={{ marginRight: 20, display: "inline-block" }}
                        >
                            Cancelar
                        </button>

                        <button className="botao-principal" disabled={isLoading}>
                            {isLoading ? <Icon type="loading" /> : null}
                            Salvar estudo
                        </button>
                    </div>
                </Form>
            </div>
        </Drawer>
    );
};

export default Form.create({ name: "form-drawer-adicionar-estudo" })(DrawerAdicionarEstudoPreEscola);
